import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { SnackBarIconService } from '../shared/snack-bar-icon/snack-bar-icon.service';
import { Account } from '../models/account';
import { AccountDialogComponent } from './dialogs/account-dialog/account-dialog.component';
import { AccountService } from '../services/account.service';
import { MatPaginator } from '@angular/material/paginator';
import { Subscription } from 'rxjs';
import { ConfirmComponent } from '../shared/dialogs/confirm/confirm.component';

import { AuthService } from '../services/auth.service';
import { Router } from "@angular/router";


@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss'],
  entryComponents: [
    AccountDialogComponent,
    ConfirmComponent
  ]
})
export class AccountComponent implements OnInit, OnDestroy {

  private sub: Subscription;
  public dataSource: MatTableDataSource<any>
  public displayedColumns: string[] = ['photoURL', 'displayName', 'edit', 'delete'];

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  
  constructor(
    private _authService: AuthService,
    private router: Router,
    private _accountsService: AccountService,
    private dialog: MatDialog,
    private snackBar: SnackBarIconService) {

      if (!this._authService.isAdmin) {
        this.router.navigate(['home']);
      }

    this.sub = this._accountsService.select()
      .subscribe((result) => {

        let array = result.map(item => {
          let account = new Account();
          account.id = item.payload.doc.id;
          account.email = item.payload.doc.data().email;
          account.displayName = item.payload.doc.data().displayName;
          account.photoURL = item.payload.doc.data().photoURL;
       //   account.phoneNumber = item.payload.doc.data().phoneNumber;
          account.disabled = item.payload.doc.data().disabled;
          account.password = item.payload.doc.data().password;
          account.confirm = item.payload.doc.data().confirm;
          account.claim_admin = item.payload.doc.data().claim_admin;
          account.claim_operator = item.payload.doc.data().claim_operator;
          account.claim_user = item.payload.doc.data().claim_user;
          return account;
        });

        this.dataSource = new MatTableDataSource(array);
       //this.dataSource.paginator = this.paginator;
        
        this.dataSource.sort = this.sort;
        this.dataSource.sort.direction = 'asc';

      },
        (error) => {
          console.log(JSON.stringify(error))
          this.snackBar.openSnackBar("Acesso negado", '', 'error');
        })

  }

  ngOnInit() {

  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  openDialog(account) {

    let accountData: Account = new Account();

    if (account) {
      accountData = account;
    } else {
      accountData = new Account();
    }

    this.dialog.open(AccountDialogComponent, {
      width: '800px',
      height: '530px',
      panelClass: 'custom-dialog-container',
      data: accountData
    });

  }

  delete(element) {
    let account_id = element.id

    let dialogRef = this.dialog.open(ConfirmComponent, {
      width: '350px',
      height: '280px',
      panelClass: 'custom-dialog-container',
      data: { title: "Confirme", message: element.displayName + "<br>" + element.email + "<br><br>Excluir esta conta?" }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {
        //this.spinner = true;
        this._accountsService.delete(account_id)
          .then(
            () => {
              this.snackBar.openSnackBar("Sucesso!", '', 'success')
              //this.spinner = false;
            }
          )
          .catch(
            (error) => { console.log("delete user error: " + error.message) }
          )
          .finally(
            () => this.dialog.closeAll()
          )

      }
    })
  }

}
